<template>
  <div>
    <h1>Edit {{ item && item['@id'] }}</h1>

    <div
      v-if="created"
      class="alert alert-success"
      role="status">{{ created['@id'] }} created.</div>
    <div
      v-if="updated"
      class="alert alert-success"
      role="status">{{ updated['@id'] }} updated.</div>
    <div
      v-if="isLoading || deleteLoading"
      class="alert alert-info"
      role="status">Loading...</div>
    <div
      v-if="error"
      class="alert alert-danger"
      role="alert">
      <span
        class="fa fa-exclamation-triangle"
        aria-hidden="true" /> {{ error }}
    </div>
    <div
      v-if="deleteError"
      class="alert alert-danger"
      role="alert">
      <span
        class="fa fa-exclamation-triangle"
        aria-hidden="true" /> {{ deleteError }}
    </div>

    <EXSBPriceTypeForm
      v-if="item"
      :handle-submit="onSendForm"
      :handle-update-field="updateField"
      :values="item"
      :errors="violations"
      :initial-values="retrieved" />

    <router-link
      v-if="item"
      :to="{ name: 'EXSBPriceTypeList' }"
      class="btn btn-default">Back to list</router-link>
    <button
      class="btn btn-danger"
      @click="del">Delete</button>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EXSBPriceTypeForm from './Form.vue'

export default {
  components: {
    EXSBPriceTypeForm
  },

  data () {
    return {
      item: {}
    }
  },

  computed: {
    ...mapGetters({
      isLoading: 'exsbpricetype/update/isLoading',
      error: 'exsbpricetype/update/error',
      deleteError: 'exsbpricetype/del/error',
      deleteLoading: 'exsbpricetype/del/isLoading',
      created: 'exsbpricetype/create/created',
      deleted: 'exsbpricetype/del/deleted',
      retrieved: 'exsbpricetype/update/retrieved',
      updated: 'exsbpricetype/update/updated',
      violations: 'exsbpricetype/update/violations'
    })
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    deleted: function (deleted) {
      if (!deleted) {
        return
      }

      this.$router.push({ name: 'EXSBPriceTypeList' })
    }
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    ...mapActions({
      createReset: 'exsbpricetype/create/reset',
      deleteItem: 'exsbpricetype/del/del',
      delReset: 'exsbpricetype/del/reset',
      retrieve: 'exsbpricetype/update/retrieve',
      updateReset: 'exsbpricetype/update/reset',
      update: 'exsbpricetype/update/update',
      updateRetrieved: 'exsbpricetype/update/updateRetrieved'
    }),

    del () {
      if (window.confirm('Are you sure you want to delete this exsbpricetype ?')) {
        this.deleteItem(this.retrieved)
      }
    },

    reset () {
      this.updateReset()
      this.delReset()
      this.createReset()
    },

    onSendForm () {
      this.update()
    },

    updateField (field, value) {
      this.updateRetrieved({ [field]: value })
    }
  }
}
</script>
